import { features } from './twm_components';

export default `awardsModule { ${features.awards} }`;
